import { Link } from 'react-router-dom';
import type { Language } from '../content';
import { Icon } from './Icon';

export function CinematicLabStory({ language }: { language: Language }) {
  const ar = language === 'ar';
  return (
    <section className="cinematic-story section section--compact">
      <div className="container cinematic-story__panel reveal">
        <figure className="cinematic-story__media">
          <img
            src="/media/dental-technician-cinematic-v2.png"
            width={1680}
            height={941}
            alt={ar ? 'فني تركيبات أسنان يعمل داخل مختبر رقمي حديث أمام ماسح وشاشة تصميم' : 'A dental technician working at a scanner and design workstation in a modern digital laboratory'}
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="cinematic-story__shade" aria-hidden="true" />
        <div className="cinematic-story__copy">
          <span className="eyebrow"><Icon name="spark" />{ar ? 'صُمم لواقع المختبر' : 'Built for real lab work'}</span>
          <h2>{ar ? 'التقنية التي تعمل بهدوء خلف كل تركيبة' : 'Technology working quietly behind every restoration'}</h2>
          <p>{ar ? 'من لحظة استلام الطلب إلى آخر فحص جودة، يبقى الفريق على نفس المسار وتبقى الإدارة على علم بما يحدث.' : 'From case intake to final quality control, the team stays on one workflow and management stays informed.'}</p>
          <div className="cinematic-story__steps" aria-label={ar ? 'دورة العمل' : 'Workflow'}>
            {[ar ? 'استلام' : 'Intake', ar ? 'تصميم' : 'Design', ar ? 'تصنيع' : 'Production', ar ? 'تسليم' : 'Delivery'].map((step, index) => <span key={step}><i>{String(index + 1).padStart(2, '0')}</i>{step}</span>)}
          </div>
          <Link className="button button--light" to="/workflow">{ar ? 'شاهد دورة العمل' : 'See the workflow'}<Icon name="arrow" /></Link>
        </div>
        <div className="cinematic-story__status"><i /><span><small>{ar ? 'حالة المختبر' : 'Lab status'}</small><strong>{ar ? 'الإنتاج يسير كما خُطط' : 'Production on plan'}</strong></span><b>94%</b></div>
      </div>
    </section>
  );
}

